import {
  SportWagerStatusEnum,
  SportWagerTypeEnum,
  TransactionStatusEnum,
  PlayerTransactionTypeEnum,
} from '@/enums'

const transaction = {
  transaction: {
    transactionType: {
      WIN: 'Win',
      BET: 'Bet',
    },
    walletType: {
      REAL: 'Real',
      BONUS: 'Bonus',
    },
    transactionTypeOptions: {
      [PlayerTransactionTypeEnum.DEPOSIT]: 'Deposit',
      [PlayerTransactionTypeEnum.WITHDRAW]: 'Withdraw',
      [PlayerTransactionTypeEnum.BONUS_DEPOSIT]: 'Bonus Deposit',
      [PlayerTransactionTypeEnum.BONUS_WITHDRAW]: 'Bonus Withdraw',
      [PlayerTransactionTypeEnum.BET]: 'Bet',
      [PlayerTransactionTypeEnum.WIN]: 'Win',
      [PlayerTransactionTypeEnum.WIN_BONUS_RELEASE]: 'Win Bonus Release',
      [PlayerTransactionTypeEnum.ROLLBACK_WIN]: 'Rollback Win',
      [PlayerTransactionTypeEnum.ROLLBACK_BET]: 'Rollback Bet',
    },
    filters: 'Filters',
    betId: 'Bet Id',
    balanceBefore: 'Balance Before',
    balanceAfter: 'Balance After',
    externalTransactionId: 'External Trans. Id',
    group: 'Group',
    transactionId: 'Transaction ID',
    transactionTypeLabel: 'Transaction Type',
    transactionStatus: 'Transaction Status',
    transactionAmount: 'Trans. Amount',
    currentRollover: 'Rollover Total',
    sportWagerStatus: 'Sport Wager Status',
    sportWagerType: 'Sport Wager Type',
    winAmount: 'Win Amount',
    riskAmount: 'Risk Amount',
    sportBetAmount: 'Sport Bet Amount',
    betDetails: 'Bet Details',
    league: 'League Name',
    sport: 'Sport Name',
    sportId: 'Sport Id',
    product: 'Product Name',
    game: 'Game Name',
    placedDate: 'Placed Date',
    pickLine: 'Pick Line',
    wasRolloverAffected: 'Was Rollover Affected',
    walletTypeText: 'Wallet Type',
    raCalculation: 'RA Calculation',
    transactionSubType: 'Transaction Subtype',
    submittedDate: 'Submitted Date',
    completedDate: 'Completed Date',
    transactionDate: 'Transaction Date',
    provider: 'Provider',
    performedBy: 'Performed By',
    subGroup: 'Subgroup',
    sportWagerStatusOptions: {
      [SportWagerStatusEnum.Lose]: 'Lose',
      [SportWagerStatusEnum.LoseByOneFourth]: 'Lose By One Fourth',
      [SportWagerStatusEnum.LoseThreeQuarters]: 'Lose Three Quarters',
      [SportWagerStatusEnum.NACancel]: 'NA Cancel',
      [SportWagerStatusEnum.NAIfBets]: 'NA If Bets',
      [SportWagerStatusEnum.NAPitchingChange]: 'NA Pitching Change',
      [SportWagerStatusEnum.NAShort]: 'NA Short',
      [SportWagerStatusEnum.NAVoid]: 'NA Void',
      [SportWagerStatusEnum.NoNet]: 'No Net',
      [SportWagerStatusEnum.Pending]: 'Pending',
      [SportWagerStatusEnum.Push]: 'Push',
      [SportWagerStatusEnum.Win]: 'Win',
      [SportWagerStatusEnum.WinByThreeQuarters]: 'Win By Three Quarters',
      [SportWagerStatusEnum.WinByOneFourth]: 'Win By One Fourth',
    },
    sportWagerTypeOptions: {
      [SportWagerTypeEnum.ACTION_POINTS]: 'Action Points',
      [SportWagerTypeEnum.BLOCK]: 'Block',
      [SportWagerTypeEnum.CARD_BET]: 'Card Bet',
      [SportWagerTypeEnum.COMPACT_IF_LOSE]: 'Compact If Lose',
      [SportWagerTypeEnum.COMPACT_IF_LOSE_OR_TIE]: 'Compact If Lose Or Tie',
      [SportWagerTypeEnum.COMPACT_IF_WIN]: 'Compact If Win',
      [SportWagerTypeEnum.COMPACT_IF_WIN_OR_TIE]: 'Compact If Win Or Tie',
      [SportWagerTypeEnum.COMPACT_REVERSE_ACTION]: 'Compact Reverse Action',
      [SportWagerTypeEnum.COMPACT_REVERSE_WIN]: 'Compact Reverse Win',
      [SportWagerTypeEnum.COMPACT_ROUND_ROBIN]: 'Compact Round Robin',
      [SportWagerTypeEnum.IF_LOSE]: 'If Lose',
      [SportWagerTypeEnum.IF_LOSE_OR_TIE]: 'If Lose Or Tie',
      [SportWagerTypeEnum.IF_WIN]: 'If Win',
      [SportWagerTypeEnum.IF_WIN_OR_TIE]: 'If Win or Tie',
      [SportWagerTypeEnum.KEY_PARLAY]: 'Key Parlay',
      [SportWagerTypeEnum.PARLAY]: 'Parlay',
      [SportWagerTypeEnum.PROPS_BUILDER]: 'Props Builder',
      [SportWagerTypeEnum.PROPS_BUILDER_WIDGET]: 'Props Builder Widget',
      [SportWagerTypeEnum.Pana_Apuestas]: 'Pana Apuestas',
      [SportWagerTypeEnum.RACING_BET]: 'Racing Bet',
      [SportWagerTypeEnum.REVERSE_ACTION]: 'Reverse Action',
      [SportWagerTypeEnum.REVERSE_WIN]: 'Reverse Win',
      [SportWagerTypeEnum.ROUND_ROBIN]: 'Round Robin',
      [SportWagerTypeEnum.Rapid_Bet]: 'Rapid Bet',
      [SportWagerTypeEnum.STRAIGHT_BET]: 'Straight Bet',
      [SportWagerTypeEnum.Star_Sports]: 'Star Sports',
      [SportWagerTypeEnum.Ultralive]: 'Ultra Live',
      [SportWagerTypeEnum._2TEAM_TEASER_Ties_Push]: 'Teaser',
      [SportWagerTypeEnum.eSPORT_STRAIGHT_BET]: 'E-Sports Straight Bet',
      [SportWagerTypeEnum.SportCast]: 'Sport Cast',
    },
    transactionStatusOptions: {
      [TransactionStatusEnum.INITIALIZED]: 'Initialized',
      [TransactionStatusEnum.PENDING]: 'Pending',
      [TransactionStatusEnum.COMPLETED]: 'Completed',
      [TransactionStatusEnum.REJECTED]: 'Rejected',
      [TransactionStatusEnum.ERROR]: 'Error',
      [TransactionStatusEnum.DEPOSIT_ROLLBACK]: 'Deposit Rollback',
      [TransactionStatusEnum.WITHDRAW_ROLLBACK]: 'Withdraw Rollback',
    },
    status: 'Status',
    search: 'Search by External & Internal Trans. ID',
  },
}

export default transaction
